module.exports = __webpack_public_path__ + "img/button_download.ac34bede.svg";